if (!customElements.get('promotion-card')) {
  customElements.define(
    'promotion-card',
    class PromotionCard extends HTMLElement {
      constructor() {
        super();
        this.handleActivation = this.handleActivation.bind(this);
        this.toggleCardActivation = this.toggleCardActivation.bind(this);
        this.isAnimating = false;
      }

      connectedCallback() {
        const promotionPointID = this.dataset.promotionPointId;
        if (promotionPointID) {
          this.promotionPoint = document.getElementById(promotionPointID);
          if (this.promotionPoint) {
            this.promotionPoint.addEventListener('click', this.handleActivation);
            this.promotionPoint.addEventListener('mouseover', this.handleActivation);
          }
          this.addEventListener('mouseover', this.toggleCardActivation);
          this.addEventListener('mouseleave', this.toggleCardActivation);
        }

        document.addEventListener('shopify:section:select', () => this.classList.add('is-active'));
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:section:select', () => this.classList.add('is-active'));
        if (this.promotionPoint) {
          this.promotionPoint.removeEventListener('click', this.handleActivation);
          this.promotionPoint.removeEventListener('mouseover', this.handleActivation);
        }
        this.removeEventListener('mouseover', this.toggleCardActivation);
        this.removeEventListener('mouseleave', this.toggleCardActivation);
      }

      toggleCardActivation(e) {
        if (this.isAnimating) return;
        if (e.type === 'mouseover' && this.classList.contains('is-expanded')) return;

        this.isAnimating = true;
        this.classList.toggle('is-expanded', e.type === 'mouseover');

        setTimeout(() => {
          this.isAnimating = false;
        }, 350);
      };

      handleActivation(e) {
        if (e.target.classList.contains('is-active')) return;

        const promotionID = this.dataset.promotionId;
        if (!promotionID) return;

        const promotion = document.getElementById(promotionID);
        if (!promotion) return;

        promotion.querySelectorAll('promotion-card, .pointer__inner').forEach((el) => {
          el.classList.remove('is-active');
        });

        e.target.classList.add('is-active');
        this.classList.add('is-active');
      }
    }
  );
}
